import keycloak from './keycloak';
import type { UserRole } from './types';
import { getLastAuthenticatedRoles } from './userIdentity';

export { UserRole } from './types';

export const checkIfRoleIsIncluded = (role: UserRole): boolean => {
  if (process.env.NODE_ENV !== 'production') {
    // Not a FeatureFlag: importing hooks/useFeatureFlag here would be circular.
    const params = new URLSearchParams(window.location.search);
    const disabledRoles = params.get('disableRoles')?.split(',') ?? [];
    if (disabledRoles.includes(role)) return false;
  }
  const roles = keycloak.tokenParsed
    ? keycloak.tokenParsed.realm_access?.roles
    : getLastAuthenticatedRoles();
  return roles?.includes(role) ?? false;
};
